import { render, staticRenderFns } from "./FinalTemperatureSection.vue?vue&type=template&id=135450c7&scoped=true&"
import script from "./FinalTemperatureSection.vue?vue&type=script&lang=js&"
export * from "./FinalTemperatureSection.vue?vue&type=script&lang=js&"
import style0 from "./FinalTemperatureSection.vue?vue&type=style&index=0&id=135450c7&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "135450c7",
  null
  
)

export default component.exports